import React, { useState, useEffect } from 'react';
import { BACKEND_URL } from '../config';
import { Lightning, X, ArrowRight } from '@phosphor-icons/react';

export default function ImprovementBanner() {
  const [event, setEvent] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const fetchLatest = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/improvements?limit=1`, { credentials: 'include' });
        if (!res.ok) return;
        const data = await res.json();
        const events = data.events || [];
        if (events.length === 0) return;

        const latest = events[0];
        // Only show non-connection events (connections handled by ActivationPanel)
        if (latest.type === 'integration_connected') return;
        // Only show events from the last 5 minutes
        const age = Date.now() - new Date(latest.created_at).getTime();
        if (age > 5 * 60 * 1000) return;

        // Don't re-show dismissed
        const dismissedId = sessionStorage.getItem('dismissed_improvement');
        if (dismissedId === latest.event_id) return;

        setEvent(latest);
      } catch {
        // silent
      }
    };
    fetchLatest();
    const interval = setInterval(fetchLatest, 30000);
    return () => clearInterval(interval);
  }, []);

  if (!event || dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem('dismissed_improvement', event.event_id);
    setDismissed(true);
  };

  const title = event.type === 'integration_connected'
    ? 'Your AI just improved'
    : event.type === 'execution_optimised'
    ? 'Execution optimised'
    : 'System updated';

  return (
    <div
      className="fixed bottom-6 right-6 z-50 max-w-sm animate-in slide-in-from-bottom-4 fade-in duration-500"
      data-testid="improvement-banner"
    >
      <div className="bg-[#1E2836] border border-[rgba(0,229,192,0.15)] rounded-2xl p-4 shadow-2xl shadow-[rgba(0,229,192,0.05)]">
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-full bg-[rgba(0,229,192,0.1)] flex items-center justify-center">
              <Lightning size={12} className="text-[#00E5C0]" weight="fill" />
            </div>
            <span className="text-[13px] font-semibold text-[#F0F4F8]" data-testid="improvement-banner-title">{title}</span>
          </div>
          <button
            onClick={dismiss}
            className="text-[#3A4150] hover:text-[#7D8896] transition-colors p-0.5"
            data-testid="improvement-banner-dismiss"
          >
            <X size={12} />
          </button>
        </div>
        <div className="space-y-1.5 ml-8">
          {(event.improvements || []).slice(0, 4).map((imp, i) => (
            <div key={i} className="flex items-center gap-2" data-testid={`improvement-item-${i}`}>
              <ArrowRight size={9} className="text-[#00E5C0] flex-shrink-0" />
              <span className="text-[12px] text-[#B0B8C4]">{imp}</span>
            </div>
          ))}
        </div>
        {event.provider_name && (
          <div className="mt-3 ml-8">
            <span className="text-[10px] text-[#3A4150]">via {event.provider_name}</span>
          </div>
        )}
      </div>
    </div>
  );
}
